import { Avatar, Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n';
import React from 'react';
import { cyrb53Hash } from 'utils/helpers';
import { WeekDaysValuesEnum } from 'modules/clients/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface SelectWeekDaysProps {
  defaultValue: any[];
  onChange: (value: any[]) => void;
}

const SelectWeekDays = ({
  defaultValue = [],
  onChange,
}: SelectWeekDaysProps) => {
  const classes = useStyles();
  const [selectedDays, setSelectedDays] = React.useState<any[]>(defaultValue);
  const weekDays = i18n.t('SHORT_WEEK_DAYS_KEY').split(',');
  const weekDaysIndexValues = [
    WeekDaysValuesEnum.SUNDAY,
    WeekDaysValuesEnum.MONDAY,
    WeekDaysValuesEnum.TUESDAY,
    WeekDaysValuesEnum.WEDNESDAY,
    WeekDaysValuesEnum.THURSDAY,
    WeekDaysValuesEnum.FRIDAY,
    WeekDaysValuesEnum.SATURDAY,
  ];

  const handleChange = index => {
    const dayValue = weekDaysIndexValues[index];
    const isExists = selectedDays.includes(dayValue);
    const newSelectedDays = isExists
      ? selectedDays.filter(day => day !== dayValue)
      : [...selectedDays, dayValue];

    setSelectedDays(newSelectedDays);
    onChange(newSelectedDays);
  };

  return (
    <Grid container justify="center">
      <Grid item className={classes.weekDays} xs={12}>
        {weekDays.map((day, index) => (
          <Avatar
            id={`option-${index}`}
            key={`option-${cyrb53Hash(String(day))}`}
            onClick={() => handleChange(index)}
            className={clsx(classes.day, {
              [classes.daySelected]: selectedDays.includes(
                weekDaysIndexValues[index]
              ),
            })}
          >
            {day}
          </Avatar>
        ))}
      </Grid>
    </Grid>
  );
};

export default SelectWeekDays;
